import { CFormInput, CFormLabel } from "@coreui/react";
import React from "react";

/**
 * @function CustomInputField
 * @description for CustomInputField
 * @returns JSX for CustomInputField
 */
const CustomInputField = ({
  type,
  size,
  name,
  placeholder,
  label,
  value,
  changeHandler,
  disabledPropery = false,
  blurhandler,
  readyOnly = false,
}) => {
  return (
    <div>
      <CFormLabel className="lable-text">{label}</CFormLabel>
      <CFormInput
        disabled={readyOnly || (disabledPropery && value)}
        type={type}
        size={size}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={changeHandler}
        {...(blurhandler && { onBlur: blurhandler })}
      />
    </div>
  );
};

export default CustomInputField;
